<template>
	<v-card class="mb-4">
		<center>
			<div class="player-container user_player">
				<vue-plyr ref="plyr">
					<video>
						<source
							v-for="src in aula.videos"
							:key="src.resolucao"
							:src="src.src"
							:type="getVideoType(src.file)"
							:size="src.resolucao"
						/>
					</video>
				</vue-plyr>
			</div>
		</center>
		<v-card-subtitle class="headline">
			<v-icon left v-if="aula.aula_completa!=null" color="amber darken-1" title="Aula assistida">far fa-chalkboard-teacher</v-icon>
			<v-icon left v-else>far fa-chalkboard-teacher</v-icon>
			{{ aula.nome }}
		</v-card-subtitle>
		<v-card-text
			v-if="aula.descricao"
			v-html="aula.descricao"
			class="ql-editor-custom ql-editor-custom-light"
		>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: {
		aula: null,
		userCursoId: undefined
	},
	data() {
		return {
			server: 'user_data',
		}
	},
	computed: {
		player() {
			return this.$refs.plyr.player
		},
		...mapState(['user']),
	},
	mounted() {
		// console.log(this.player)
		// https://github.com/sampotts/plyr#events
		this.player.on('ended', () => {
			this.aulaCompleta()
		})
	},
	methods: {
		getVideoType(file) {
			let array = file.split('.')
			let type = array[array.length - 1]
			return 'video/' + type
		},
		aulaCompleta(){
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'insert_aula_completa')
			formData.append('user_id', this.user.id)
			formData.append('aula_id', this.aula.id)
			formData.append('user_curso_id', this.userCursoId)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('searchAula', { value: true })
					}
					console.log(response.data.alertMessage)
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		}
	},
}
</script>
<style lang="css">
.user_player {
	max-width: 1800px;
}
</style>
